import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { api, type Session } from './api.js';
import { SignIn } from './SignIn.js';
import { App } from './App.js';

/**
 * Starting up.
 *
 * One request decides which of two screens this is, and there is nothing else to arrange: no
 * offline database, no service worker, no router. A customer arrives here from a link or a
 * bookmark, on a device with signal, two or three times a year.
 */
function Root() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  const check = () => {
    void api
      .session()
      .then(setSession)
      .catch(() => setSession(null));
  };

  useEffect(check, []);

  if (session === undefined) return <div className="loading" aria-busy="true" aria-label="Chargement" />;
  if (session === null) return <SignIn onSignedIn={check} />;
  return <App onSignedOut={() => setSession(null)} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
